import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/modules/material.module';

import { LabelDataAssetCreateComponent } from './actions/label-data-asset-create/label-data-asset-create.component';
import { DownloadIttActionComponent } from './actions/download-itt-action/download-itt-action.component';
import { LabelDataProductCreateActionComponent } from './actions/label-data-product-create-action/label-data-product-create-action.component';
import { LabelDataProductCreateComponent } from './label-data-product-create/label-data-product-create.component';

const COMPONENTS = [
  DownloadIttActionComponent,
  LabelDataAssetCreateComponent,
  LabelDataProductCreateActionComponent,
  LabelDataProductCreateComponent,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule, MaterialModule],
  exports: COMPONENTS,
})
export class LabelDataModule {}
